/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Legend_VpInputs */



/**
* | output |
* | --- |
* | "Victory points" |
*
* @param {Score_Legend_VpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const score_legend_vp = /** @type {((inputs?: Score_Legend_VpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Legend_VpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points de victoire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntos de victoria")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontos de vitória")
	if (locale === "it") return /** @type {LocalizedString} */ ("Victory points")
	return /** @type {LocalizedString} */ ("Victory points")
});